/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotAutoResumeStatusResponse,
  ApiEnvelopeBotEngineMetricHistoryResponse,
  ApiEnvelopeBotEngineStatsResponse,
  ApiEnvelopeBotShutdownStatusResponse,
  ApiEnvelopeBotSystemQueueHistoryResponse,
  BotStatsGetHistoryParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botStatsGetStatsResponse200 = {
  data: ApiEnvelopeBotEngineStatsResponse
  status: 200
}

export type botStatsGetStatsResponse401 = {
  data: ApiEnvelopeBotEngineStatsResponse
  status: 401
}

export type botStatsGetStatsResponse403 = {
  data: ApiEnvelopeBotEngineStatsResponse
  status: 403
}

export type botStatsGetStatsResponseSuccess = (botStatsGetStatsResponse200) & {
  headers: Headers;
};
export type botStatsGetStatsResponseError = (botStatsGetStatsResponse401 | botStatsGetStatsResponse403) & {
  headers: Headers;
};

export type botStatsGetStatsResponse = (botStatsGetStatsResponseSuccess | botStatsGetStatsResponseError)

export const getBotStatsGetStatsUrl = () => {




  return `/api/botengine/stats`
}

export const useBotStatsGetStatsHook = (): ( options?: RequestInit) => Promise<botStatsGetStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotStatsGetStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botStatsGetSystemQueueHistoryResponse200 = {
  data: ApiEnvelopeBotSystemQueueHistoryResponse
  status: 200
}

export type botStatsGetSystemQueueHistoryResponse401 = {
  data: ApiEnvelopeBotSystemQueueHistoryResponse
  status: 401
}

export type botStatsGetSystemQueueHistoryResponse403 = {
  data: ApiEnvelopeBotSystemQueueHistoryResponse
  status: 403
}

export type botStatsGetSystemQueueHistoryResponseSuccess = (botStatsGetSystemQueueHistoryResponse200) & {
  headers: Headers;
};
export type botStatsGetSystemQueueHistoryResponseError = (botStatsGetSystemQueueHistoryResponse401 | botStatsGetSystemQueueHistoryResponse403) & {
  headers: Headers;
};

export type botStatsGetSystemQueueHistoryResponse = (botStatsGetSystemQueueHistoryResponseSuccess | botStatsGetSystemQueueHistoryResponseError)

export const getBotStatsGetSystemQueueHistoryUrl = () => {




  return `/api/botengine/stats/system-queue-history`
}

export const useBotStatsGetSystemQueueHistoryHook = (): ( options?: RequestInit) => Promise<botStatsGetSystemQueueHistoryResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotStatsGetSystemQueueHistoryUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botStatsGetHistoryResponse200 = {
  data: ApiEnvelopeBotEngineMetricHistoryResponse
  status: 200
}

export type botStatsGetHistoryResponse401 = {
  data: ApiEnvelopeBotEngineMetricHistoryResponse
  status: 401
}

export type botStatsGetHistoryResponse403 = {
  data: ApiEnvelopeBotEngineMetricHistoryResponse
  status: 403
}

export type botStatsGetHistoryResponseSuccess = (botStatsGetHistoryResponse200) & {
  headers: Headers;
};
export type botStatsGetHistoryResponseError = (botStatsGetHistoryResponse401 | botStatsGetHistoryResponse403) & {
  headers: Headers;
};

export type botStatsGetHistoryResponse = (botStatsGetHistoryResponseSuccess | botStatsGetHistoryResponseError)

export const getBotStatsGetHistoryUrl = (params?: BotStatsGetHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/stats/history?${stringifiedParams}` : `/api/botengine/stats/history`
}

export const useBotStatsGetHistoryHook = (): (params?: BotStatsGetHistoryParams, options?: RequestInit) => Promise<botStatsGetHistoryResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BotStatsGetHistoryParams, options?: RequestInit) => {

        return customFetcher(getBotStatsGetHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botStatsGetAutoResumeStatusResponse200 = {
  data: ApiEnvelopeBotAutoResumeStatusResponse
  status: 200
}

export type botStatsGetAutoResumeStatusResponse401 = {
  data: ApiEnvelopeBotAutoResumeStatusResponse
  status: 401
}

export type botStatsGetAutoResumeStatusResponse403 = {
  data: ApiEnvelopeBotAutoResumeStatusResponse
  status: 403
}

export type botStatsGetAutoResumeStatusResponseSuccess = (botStatsGetAutoResumeStatusResponse200) & {
  headers: Headers;
};
export type botStatsGetAutoResumeStatusResponseError = (botStatsGetAutoResumeStatusResponse401 | botStatsGetAutoResumeStatusResponse403) & {
  headers: Headers;
};

export type botStatsGetAutoResumeStatusResponse = (botStatsGetAutoResumeStatusResponseSuccess | botStatsGetAutoResumeStatusResponseError)

export const getBotStatsGetAutoResumeStatusUrl = () => {




  return `/api/botengine/stats/autoresume`
}

export const useBotStatsGetAutoResumeStatusHook = (): ( options?: RequestInit) => Promise<botStatsGetAutoResumeStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotStatsGetAutoResumeStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botStatsGetShutdownStatusResponse200 = {
  data: ApiEnvelopeBotShutdownStatusResponse
  status: 200
}

export type botStatsGetShutdownStatusResponse401 = {
  data: ApiEnvelopeBotShutdownStatusResponse
  status: 401
}

export type botStatsGetShutdownStatusResponse403 = {
  data: ApiEnvelopeBotShutdownStatusResponse
  status: 403
}

export type botStatsGetShutdownStatusResponseSuccess = (botStatsGetShutdownStatusResponse200) & {
  headers: Headers;
};
export type botStatsGetShutdownStatusResponseError = (botStatsGetShutdownStatusResponse401 | botStatsGetShutdownStatusResponse403) & {
  headers: Headers;
};

export type botStatsGetShutdownStatusResponse = (botStatsGetShutdownStatusResponseSuccess | botStatsGetShutdownStatusResponseError)

export const getBotStatsGetShutdownStatusUrl = () => {




  return `/api/botengine/stats/shutdown`
}

export const useBotStatsGetShutdownStatusHook = (): ( options?: RequestInit) => Promise<botStatsGetShutdownStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotStatsGetShutdownStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


